import { render, staticRenderFns } from "./FavElement.vue?vue&type=template&id=18a449d9&"
import script from "./FavElement.vue?vue&type=script&lang=js&"
export * from "./FavElement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('18a449d9')) {
      api.createRecord('18a449d9', component.options)
    } else {
      api.reload('18a449d9', component.options)
    }
    module.hot.accept("./FavElement.vue?vue&type=template&id=18a449d9&", function () {
      api.rerender('18a449d9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2O8L2ShFSGyBz/JS/comp/FavElement.vue"
export default component.exports